import { useState } from "react";
import { Link } from "react-router-dom";
import { observer } from "mobx-react";
import useStores from "../../utils/useStores";
import AuthShell from "./AuthShell";

function ForgotPassword() {
    const rootStore = useStores();
    const [email, setEmail] = useState("");
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);

    function handleSubmit(e: React.FormEvent) {
        e.preventDefault();
        setLoading(true);

        rootStore.profileStore.forgotPassword(email, (hasError: boolean) => {
            setLoading(false);
            // Always show success — the server never reveals if the email exists
            setSubmitted(true);
        });
    }

    if (submitted) {
        return (
            <AuthShell eyebrow="Instructions sent" title="Check your email" description="Password reset links expire, so use it when it arrives.">
                <div className="auth-card__message" role="status">
                    <p>
                        If <strong>{email}</strong> is registered, you'll receive a link to reset your password shortly.
                    </p>
                    <Link to="/login" className="auth-link">
                        Back to sign in
                    </Link>
                </div>
            </AuthShell>
        );
    }

    return (
        <AuthShell eyebrow="Account recovery" title="Reset your password" description="Enter your email and we’ll send a private reset link if there’s an account attached to it.">
                <form className="auth-form" onSubmit={handleSubmit}>
                    <div className="auth-field">
                        <label htmlFor="forgot-email">Email</label>
                        <input
                            id="forgot-email"
                            type="email"
                            autoComplete="email"
                            placeholder="Email Address"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            required
                        />
                    </div>

                    <div className="auth-form__actions">
                        <button
                            type="submit"
                            disabled={loading}
                            className="auth-button"
                        >
                            {loading ? "Sending…" : "Send reset instructions"}
                        </button>
                        <p className="auth-form__meta auth-form__meta--centered">
                            <Link to="/login" className="auth-link">Back to sign in</Link>
                        </p>
                    </div>
                </form>
        </AuthShell>
    );
}

export default observer(ForgotPassword);
